/**
 * WaveEffects - SVG-based wave and sine wave animations
 * Lightweight, disabled on low-end devices
 */
function WaveEffects() {
  return (
    <>
      {/* Sine wave animation */}
      <svg className="sine-wave" viewBox="0 0 800 200">
        <defs>
          <linearGradient id="dotGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" style={{ stopColor: 'rgba(100,200,255,0.6)', stopOpacity: 1 }} />
            <stop offset="50%" style={{ stopColor: 'rgba(100,200,255,1)', stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: 'rgba(100,200,255,0.6)', stopOpacity: 1 }} />
          </linearGradient>
        </defs>
        <path
          id="sine-path"
          className="wave"
          d="M0,100 Q50,50 100,100 T200,100 T300,100 T400,100 T500,100 T600,100 T700,100 T800,100"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
        />
        {/* Gradient dots following sine path */}
        {[0, 1, 2, 3, 4, 5, 6].map((i) => (
          <g key={i}>
            <circle cx="0" cy="0" r="5" fill="url(#dotGradient)" opacity={1 - i * 0.14}>
              <animateMotion dur="8s" repeatCount="indefinite" begin={`${i * 0.5}s`}>
                <mpath href="#sine-path" />
              </animateMotion>
            </circle>
          </g>
        ))}
      </svg>
    </>
  );
}

export default WaveEffects;
